"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAccessibleDashboardList = void 0;
function loadAccessibleDashboardList(ctx) {
    var backend = ctx.backend, workspace = ctx.workspace;
    return backend.workspace(workspace).dashboards().getDashboards({ includeAvailableViaLink: true });
}
exports.loadAccessibleDashboardList = loadAccessibleDashboardList;
//# sourceMappingURL=loadAccessibleDashboardList.js.map